/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { useLocation } from "@reach/router"

function SEO({ description, lang, meta, title, image }) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
            image
          }
        }
      }
    `
  )
  let titleSeo = title || site.siteMetadata?.title
  let metaDescription = description || site.siteMetadata.description 
  let defaultTitle = site.siteMetadata?.title
  var { pathname } = useLocation()

  if (pathname == "/home/" || pathname == "/home" )
    pathname = "/"
  
  var curentUrl = '';
  curentUrl = process.env.GATSBY_SITE_URL+pathname;
  if (!curentUrl.endsWith('/'))
      curentUrl = curentUrl + '/';

  //remove multiple slashes
  curentUrl = curentUrl.replace(/([^:]\/)\/+/g, "$1");
  //set lowercase url
  curentUrl = curentUrl.toLowerCase();

  var canonicalUrl = "";
  if(pathname === "/new-agents/"){
    canonicalUrl = process.env.GATSBY_SITE_URL + "/agents-win-more-instructions/";
  } else if(pathname === "/new-conveyancers/"){
    canonicalUrl = process.env.GATSBY_SITE_URL + "/conveyancers/";
  }else{
    canonicalUrl = curentUrl;
  }


  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      link={[
        {
            href: canonicalUrl,
            rel: "canonical"
        }
      ]}
      title={titleSeo}
      titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:image`,
          content: image ? image : "",
        },
        {
          property: `og:url`,
          content: curentUrl,
        },
        {
          property: `og:image:secure_url`,
          content: image ? image : "",
        },
        {
          property: `og:image:type`,
          content: `image/jpeg`,
        },
        {
          property: `og:image:width`,
          content: `400`,
        },
        {
          property: `og:image:height`,
          content: `300`,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata?.author || ``,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `facebook-domain-verification`,
          content: ``,
        },
        {
          name: `google-site-verification`,
          content: `Li_l_Cp54GJu9hU9qeY2zQ9tXFYI0mlueDhqEVUojq0`,
        },
      ].concat(meta)}
    />
  )
}

SEO.defaultProps = {
  lang: `en`,
  meta: [],
  description: ``,
  image: null,
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  image: PropTypes.string,

}

export default SEO
